import { render, staticRenderFns } from "./FormTemplates.vue?vue&type=template&id=cdd79226&scoped=true"
import script from "./FormTemplates.vue?vue&type=script&lang=js"
export * from "./FormTemplates.vue?vue&type=script&lang=js"
import style0 from "./FormTemplates.vue?vue&type=style&index=0&id=cdd79226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd79226",
  null
  
)

export default component.exports